import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { DropdownItem } from 'reactstrap';

import classnames from 'classnames';
import styles from './index.module.scss';

export class DropdownItemV2 extends Component {
  static propTypes = {
    legend: PropTypes.bool,
    onClick: PropTypes.func,
  };

  render() {
    const { legend, onClick, className, children, ...other } = this.props;

    const defaultClasses = classnames(className, styles.dropdownItem, {
      [styles.onClick]: !!onClick,
    });

    return (
      <DropdownItem className={defaultClasses} onClick={onClick} {...other}>
        {legend ? <small className="text-muted">{children}</small> : children}
      </DropdownItem>
    );
  }
}

export default DropdownItemV2;
